import { throwDialogContentAlreadyAttachedError } from '@angular/cdk/dialog';
import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { take } from 'rxjs';
import { AppService } from '../../app.service';
import { AppSettings } from '../../app.settings';
import { Client } from '../../models/client';
import { MoovConfiguration } from '../../models/moovConfiguration';
import { MoovStepPremierServiceConfiguration } from '../../models/moovStepPremierServiceConfiguration';
import { PremierPartner } from '../../models/premierPartner';
import { AccountService } from '../../services/AccountService';

@Component({ standalone:false,
  selector: 'app-execute-premier-integration-dialog',
  templateUrl: './execute-premier-integration-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./execute-premier-integration-dialog.component.scss']
})
export class ExecutePremierIntegrationDialogComponent implements OnInit {
  public title:string='';
  public message:string='';
  public executeButtonText="Execute";
  public cancelButtonText="Cancel";
  public advancedOptionsExpanded = false; 

  public parameterForm:FormGroup;
  public moovConfiguration!:MoovConfiguration;
  public client!:Client;
  //public customerConfigurationName!:string;
  public moovStepPremierServiceConfiguration!:MoovStepPremierServiceConfiguration;
  public premierPartner?:PremierPartner;
  public premierServiceProductType?:string;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<ExecutePremierIntegrationDialogComponent>, private appSettings:AppSettings, private accService:AccountService) { 
    this.parameterForm = new FormGroup({
      ids: new FormControl(undefined),
      processedOnError: new FormControl(false)
    });
  }

  ngOnInit(): void {
    if(this.data){
      this.title=this.data.title;
      this.message=this.data.message;
      this.moovConfiguration=this.data.moovConfiguration;
      this.moovStepPremierServiceConfiguration=this.data.moovStepPremierServiceConfiguration;
      this.client=this.data.client;   
     
      this.accService.getPremierPartners(false).pipe(take(1)).subscribe(partnerArray=>{
        this.premierPartner=partnerArray.find(p=>p.id==this.moovStepPremierServiceConfiguration.premierPartnerId);
        this.premierServiceProductType = this.moovStepPremierServiceConfiguration.premierServiceProductType;
        this.setValidators();
      });
    }
  }
  
  get canSubmit(){
    return this.parameterForm.valid;
  }

  get premierPartnerName(){
    return this.premierPartner?.name;
  }

  get premierPartnerProviderName(){
    return this.premierPartner?.providerName;
  }

  get idsToProcessName(){
    if(this.premierPartnerProviderName == "prismhr"){
      return "Batch IDs to process";
    }
    else if(this.premierPartnerProviderName == "execupay"){
      return "Payroll IDs to process";
    }
    else if(this.premierPartnerProviderName  == "prismhcm"){
      if(this.premierServiceProductType=="401K" || this.premierServiceProductType=="payroll") return "Payrolls Summary IDs to process";
      else return "";
    }
    else if(this.premierPartnerProviderName == "prosoftware"){
      return "Payroll numbers to process";
    }
    else if(this.premierPartnerProviderName == "primepay_spay"){
      return "Pay Process IDs to process";
    }
    else if(this.premierPartnerProviderName == "isolved"){
      return "Payroll run numbers to process";
    }
    else{
      return "IDs to process";
    }
  }

  get parameterListName(){
    return (this.premierPartnerProviderName && this.premierServiceProductType) ? AppService.getPremierPartnerOptionalParameterListName(this.premierPartnerProviderName, this.premierServiceProductType) : '';
  }

  get hideParameterForm(){
     return this.premierPartnerProviderName == "generic" || (this.premierPartnerProviderName == "prismhcm" && !(this.premierServiceProductType=="401K" || this.premierServiceProductType=="payroll")) || (this.premierPartnerProviderName == "isolved" && (this.premierServiceProductType=="employee" || this.premierServiceProductType=="pto")); //need to change this for prismhcm once more products are being integrated
  }

  private setValidators(){
    if(this.premierPartnerProviderName == "prismhr"){
      this.parameterForm.get('ids')!.setValidators(Validators.pattern(this.appSettings.batchIdsRegex));
    }
    else if(this.premierPartnerProviderName == "execupay" || this.premierPartnerProviderName == "primepay_spay" || (this.premierPartnerProviderName == "prismhcm" && (this.premierServiceProductType=="401K" || this.premierServiceProductType=="payroll"))){
      this.parameterForm.get('ids')!.setValidators(Validators.pattern(this.appSettings.payrollIdsRegex));
    }
    else{
      this.parameterForm.get('ids')!.clearValidators();;
    }
    this.parameterForm.updateValueAndValidity();
  }
  
  public onAdvancedOptionsClick() {
    this.advancedOptionsExpanded = !this.advancedOptionsExpanded;
  }

  public onCancelClick(){
    this.dialogRef.close(false);
  }

  public onExecuteClick(){
    if(this.hideParameterForm){
      this.dialogRef.close([]);
    }
    else if(this.parameterForm.valid){
      let formIds = this.parameterForm.get('ids')!.value as string;
      let arrayOfParameters=new Array<{name:string,value:string}>();
      let obj = {name: this.parameterListName, value:formIds}
      let processedOnError = this.parameterForm.get('processedOnError')!.value ? "true" : "false";
      if(obj.value)arrayOfParameters.push(obj);
      arrayOfParameters.push({name: "processedOnError", value: processedOnError});
      this.dialogRef.close(arrayOfParameters);
    }
  }

}
